export enum TagSearchFilterStyle {
    Default,
    SearchActionButton
}

export enum TagSearchFilterModifier {
    'NoBorder' = '-sh-remove-border'
}
